import React, { ReactElement } from "react";
import styles from "./Loading.module.css";

interface LoadingProps {
  loading: boolean;
  loadingText: string;
  backgroundColor?: string;
}

const Loading: React.FC<LoadingProps> = ({
  loading,
  loadingText,
  backgroundColor,
  ...rest
}): ReactElement => {
  if (loading) {
    return (
      <div className={styles.loading} {...rest}>
        <div className={styles.loading_container} style={{ backgroundColor }}>
          <div className={styles.lds_spinner}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className={styles.text}>{loadingText}</div>
        </div>
      </div>
    );
  }
  return <div />;
};

export default Loading;
